// import Backbone from 'backbone';
import tmpl from '../templates';
import OptionGroupListView from './optionGroupListView';
import ImageListItem from '../models/imageListItem';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var ConfigurationItemView = Backbone.View.extend( {
    tagName: 'li',
    className: 'group-item grid-item',
    attributes: {
        tabindex: 0,
        role: 'option'
    },

    template: _.template( tmpl.configurationItem ),

    events: {
        'click': 'handleSelect'
    },

    initialize: function () {
        if ( this.model.hasOptionGroups() ) {
            this.optionGroupListView = new OptionGroupListView( {collection: this.model.optionGroupList} );
        }

        this.listenTo( this.model, 'change:selected', this.updatePriceModule );
        this.listenTo( this.model, 'error', this.onError );
        this.listenTo( this.model, 'change:option', () => {
            this.handleOptionChange();
            this.updateSelectedSku();
        } );
        this.listenTo( this.model, 'change:selected', sku => {
            const isConfigurationSelected = this.model.get( 'selected' );
            if ( !isConfigurationSelected ) {
                return;
            }

            this.updateSelectedSku( sku );
        } );

        this.listenTo( this.model, 'change:selected', this.render );

    },

    close: function () {
        this.closeOptionGroupView();
        this.undelegateEvents();
        this.stopListening( this.model );
        this.remove();
    },

    render: function () {
        this.$el.html( this.template( this.serializeData() ) );
        this.toggleSelected();
        return this;
    },

    serializeData: function () {
        var m = this.model,
            thumbnail = new ImageListItem( m.get( 'images' )[0] );

        return {
            // only serialize what is needed
            'name': m.get( 'name' ),
            'thumbnailSrc': thumbnail.getImageSrc( 'small' ),
            'selected': m.get( 'selected' )
        };
    },

    renderOptionGroups: function () {
        return this.showOptionGroupView( this.optionGroupListView );
    },

    handleSelect: function () {
        this.model.select();
    },

    updatePriceModule: function () {
        if ( this.isSelected() ) {
            app.mediator.trigger( 'set:skulist', this.model.getSkuList() );
        }
    },

    updateSelectedSku: function () {
        var sku = this.model.getSelectedSku();
        // pass selected sku or null to SkuItemController to render
        if ( sku ) {
            app.mediator.trigger( 'set:sku', sku );
        }
    },

    handleOptionChange: function () {
        var sku = this.model.getSelectedSku();
        // execute if configuration is "selected", ignoring items moving to the "unselected" state
        if ( !sku && this.model.get( 'selected' ) ) {
            // reset supplementary content for current configuration item if selection NOT at the sku level
            this.resetSupplementaryContent();
        }
    },

    toggleSelected: function () {
        this.$el.toggleClass( 'selected', this.model.get( 'selected' ) );
    },

    resetSupplementaryContent: function () {
        app.imageCollection.reset( this.model.get( 'images' ) );
        app.mediator.trigger( 'toggle:customprinting', false );
    },

    onError: function ( err ) {
        // todo: should keep track of option-set-list childViews
        app.validator.trigger( 'error:validation', {
            type: err.type,
            message: err.message,
            el: $( '.option-set[data-group-id="' + this.model.get( 'groupId' ) + '"] .group-label' )
        } );

    },

    /**
     * Garbage Collection
     */
    showOptionGroupView: function ( view ) {
        this.closeOptionGroupView();
        this._currentOptionGroupView = view;
        // appending to DOM is delegated to parentView => ConfigurationListView
        return view.render().el;
    },

    closeOptionGroupView: function () {
        var existingView = this._currentOptionGroupView;
        if ( existingView ) {
            existingView.close();
            this._currentOptionGroupView = null;
        }
    },

    isSelected: function () {
        return !!this.model.get( 'selected' );
    }

} );

export default ConfigurationItemView;
